export default {
  computed: {
    isTabletOrBigger () {
      return window.innerWidth > 767
    },
    isTablet () {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera
      if (
        /windows phone/i.test(userAgent) ||
        /android/i.test(userAgent) ||
        /iPad/.test(userAgent)
      ) return window.innerWidth > 767

      return false
    },
    isIpad () {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera
      if (/iPad/.test(userAgent)) return true

      return false
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/breakpoints.js